// Gallery widget

class GalleryImage {
    constructor(element, toggle, numOfItems = {}) {
        this.element = element[0];
        this.toggle = toggle[0];
        this.images = [...element.children()];
        this.toggleIn = 0;
        // remove toggle from list of images 
        var i = Array.prototype.indexOf.call(this.images, this.toggle);
        if (i > -1 ) {
            this.images.splice(i, 1);
            this.toggleIn = 1;        
        }
        // default values
        if(Object.keys(numOfItems).length == 0) {
            numOfItems = {
                "default": 7,
                "tablet": 5,
                "mobile": 3
            };
        }
        this.numOfItems = numOfItems;
        this.init();
    }
    init() {
        const that = this;

        if (that.images.length <= this.numberOfItems()) {
            that.toggle.classList.add("hidden");
        }

        that.toggle.addEventListener('click', function toggleHandler(e) {
            e.preventDefault();
            that.show();
            const hiddenCount = that.images.filter(image => image.classList.contains("hidden")).length;
            if (hiddenCount == 0) {
                that.toggle.classList.add("hidden");
            }
        });

        this.images.map((el, index) => {
            if (index >= this.numberOfItems()) {
                if (!el.classList.contains("next-fotos")) {
                    el.classList.add('hidden');                    
                    if (el.classList.contains('fotogalery-item')) {
                        el.querySelector("a").dataset.fancybox = "";
                    }
                }
            }
        });
        this.element.classList.add('ready');
    }
    show() {
        const hiddenEls = this.images.filter(image => image.classList.contains("hidden"));
        hiddenEls.map((el, index) => {
            if (index < this.numberOfItems() + this.toggleIn) {
                el.classList.remove('hidden');
                if (el.classList.contains('fotogalery-item')) {
                    el.querySelector("a").dataset.fancybox = "group";
                }
            }
        });
    }

    numberOfItems() {        
        num = this.numOfItems;
        if (num.mobile && window.innerWidth <= 640) return num.mobile;
        if (num.tablet && window.innerWidth <= 1024) return num.tablet;
        if (num.default) return num.default;
    }
}
